/**
 * Copyright 2016, Fullstack.io, LLC.
 *
 * This source code is licensed under the MIT-style license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { Action, ActionCreator } from 'redux';

/*import { uuid } from '../util/uuid';
import { Message } from '../message/message.model';
import { User } from '../user/user.model';*/

/**
 * ThreadActions specifies _action creators_ (i.e. objects that describe
 * changes to the reducers) that are concerned with Threads and Messages
 */
/*export const ADD_THREAD = '[Thread] Add';

export interface AddThreadAction extends Action {
  thread: Thread;
}
export const addThread: ActionCreator<AddThreadAction> =
  (thread) => ({
    type: ADD_THREAD,
    thread: thread
  });*/

export const ADD_INSTRUMENT = '[Futures] Add future';

export interface AddInstrumentAction extends Action {
  group: any;
  instrument: any;
}

export const addInstrument: ActionCreator<AddInstrumentAction> =
  (group: any, instrumentArgs: any): AddInstrumentAction => {
    const defaults = {
      group: group
    };
    const instrument: any = Object.assign({}, defaults, instrumentArgs);

    return {
      type: ADD_INSTRUMENT,
      group: group,
      instrument: instrument
    };
  };


export const ADD_GROUP = '[Futures] Add Group future';

export interface AddGroupAction extends Action {
  group: any;
}

export const addGroup: ActionCreator<AddGroupAction> =
  (groupArgs: any): AddGroupAction => {
    const group: any = Object.assign({}, groupArgs);
    return {
      type: ADD_GROUP,
      group: group
    };
  };


export const ADD_DEFAULT_GROUP = '[Futures] Add Default Group future';

export interface AddDefaultGroupAction extends Action {
  group: any;
}

export const addDefaultGroup: ActionCreator<AddDefaultGroupAction> =
  (groupArgs: any): AddDefaultGroupAction => {

    const group: any = Object.assign({}, groupArgs);

    return {
      type: ADD_DEFAULT_GROUP,
      group: group
    };
  };


export const SELECT_GROUP = '[Futures] Select group future';

export interface SelectGroupAction extends Action {
  groupId: any;
}

export const selectGroup: ActionCreator<SelectGroupAction> =
  (groupId) => ({
    type: SELECT_GROUP,
    groupId: groupId
  });


export const DELETE_GROUP = '[Futures] Delete group future';

export interface DeleteGroupAction extends Action {
  groupId: number;
  newCurrentGroupId: number;
}

export const deleteGroup: ActionCreator<DeleteGroupAction> =
  (groupId, newCurrentGroupId?) => ({
    type: DELETE_GROUP,
    groupId: groupId,
    newCurrentGroupId: newCurrentGroupId ? newCurrentGroupId : 0
  });
